import { Injectable } from '@angular/core';

import { CounterWidgetDataEntryEndUserDto, DataEntry } from '@osos/shared/api';
import { ParserBase } from '../../bases/parser/parser-base';

import {
  CounterUserEntryPresenterModel,
  DataEntryPresenterModel,
} from '@osos/shared/types';

@Injectable({
  providedIn: 'root',
})
export class CounterUserEntryParserV1Service extends ParserBase<
  CounterWidgetDataEntryEndUserDto,
  CounterUserEntryPresenterModel
> {
  constructor() {
    super(CounterWidgetDataEntryEndUserDto, CounterUserEntryPresenterModel, 1);
  }
  getPresenterModel(
    model: CounterWidgetDataEntryEndUserDto,
  ): CounterUserEntryPresenterModel {
    return {
      specificationVersion: this.version,
      id: model.id,
      dataEntity: model.dataEntity,
      value: model.value,
      isIncludedInQueryResult: model.isIncludedInQueryResult,
      state: model.state,
      creationInfo: model.creationInfo,
      updateInfo: model.updateInfo,
      entityVersion: model.entityVersion ?? 0,
      isEntryObsolete: model.invalidReason === 0,
      isImplicit: model.isImplicit,
    } as DataEntryPresenterModel;
  }
  getDataModel(
    presenter: DataEntryPresenterModel,
  ): CounterWidgetDataEntryEndUserDto {
    const model = {
      specificationVersion: this.version,
      dataEntity: presenter.dataEntity,
      value: { ...presenter.value },
      state: presenter.state,
    } as DataEntry;

    return model;
  }
}
